module.exports = __webpack_public_path__ + "923d9a985d2bf5a76e8cdb4a170e234a.svg";